import formatAsCurrency from '../../CommonUtils/formatAsCurrency';
import formatValue from '../../CommonUtils/formatValue';

const assumptions = [
  {
    key: 'PersonalInformation',
    title: 'Personal Information',
    template: value => `${value.Name}: Year of Birth ${value.Yob}`,
  },
  {
    key: 'PartnersInformation',
    title: 'Partner’s Information',
    template: value => `${value.Name}: Year of Birth ${value.Yob}`,
  },
  {
    key: 'Children',
    title: 'Children',
    template: value => `${value.Name}: Year of Birth ${value.Yob}`,
  },
  {
    key: 'EmploymentIncome',
    title: 'Employment Income',
    template: value => `${value.Owner}: ${formatAsCurrency(value.Amount)}`,
  },
  {
    key: 'BusinessIncome',
    title: 'Business Income',
    template: value => `${value.Owner}: ${formatAsCurrency(value.Amount)}`,
  },
  {
    key: 'RealEstateIncome',
    title: 'Real Estate Income',
    template: value => `${value.Owner}: ${formatAsCurrency(value.Amount)}`,
  },
  {
    key: 'OtherIncome',
    title: 'Other Income',
    template: value => `${value.Owner}: ${formatAsCurrency(value.Amount)}`,
  },
  {
    key: 'EffectiveTaxRate',
    title: 'Effective Tax Rate',
    template: value => formatValue(value, { type: 'percent', decimalPlaces: 2 }),
  },
  {
    key: 'TaxFilingState',
    title: 'Tax Filing State',
    template: value => value,
  },
  {
    key: 'PreRetirementOverrideState',
    title: 'Pre-Retirement Override State',
    template: value => value,
  },
  {
    key: 'PreRetirementOverrideEffectiveTaxRate',
    title: 'Pre-Retirement Override Effective Tax Rate',
    template: value => formatValue(value, { type: 'percent', decimalPlaces: 2 }),
  },
  {
    key: 'TaxFilingStatus',
    title: 'Tax Filing Status',
    template: value => value,
  },
  {
    key: 'RetirementState',
    title: 'Retirement State',
    template: value => value,
  },
  {
    key: 'RetirementEffectiveTaxRate',
    title: 'Retirement Effective Tax Rate',
    template: value => formatValue(value, { type: 'percent', decimalPlaces: 2 }),
  },
  {
    key: 'InflationRate',
    title: 'Inflation Rate',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    key: 'CurrentLivingExpenses',
    title: 'Current Living Expenses',
    template: value => `${formatAsCurrency(value)} Per Month`,
  },
  {
    key: 'RiskToleranceModel',
    title: 'Risk Tolerance Model',
    template: value => value,
  },
];

export default assumptions;
